export const validateEmail = (email) => {
    // 入力がメールアドレスの正規表現に一致することを確認します。
    
    if (!/^\w+@\w+\.\w+$/.test(email)) {
      return false;
    }
  
    // 入力がメールアドレスの正規表現に一致します。
    return true;            
    };


export const validateRequired = (value) => {
    // 入力がメールアドレスの正規表現に一致することを確認します。
    
    // if (value.length > 0) {
    if ((value != null) && (value.length != 0) ) {        
        return true;
    }
    
    // 入力がメールアドレスの正規表現に一致します。
    return false;            
    };    


export const validateDecimal = (value) => {
    // 入力がメールアドレスの正規表現に一致することを確認します。
    
    if ( value == 0.0 ) {
        return true;
    }
    
    // 入力がメールアドレスの正規表現に一致します。
    return false;            
    };    

export const validateDigit = (value) => {
    // 入力がメールアドレスの正規表現に一致することを確認します。
    
    if (/^\d+$/.test(value)) {
        return true;
    }
    
    // 入力がメールアドレスの正規表現に一致します。
    return false;            
    };            

export const validateNofD = (min,max,value) => {
    // 入力がメールアドレスの正規表現に一致することを確認します。
    
    if (value >= min && value <= max) {
        return true;
    }
    
    // 入力がメールアドレスの正規表現に一致します。
    return false;            
    };            
